module.exports = __webpack_public_path__ + "static/media/8OLA25.6fb10d7a.jpg";